import React from "react";
import {Alert} from "@mui/material";
import {useStores} from "../../../../../../stores";
import {observer} from "mobx-react-lite";

export const ToolbarAlerts: React.FC = observer(() => {
    const {categorizationReviewStore} = useStores()
    return <>
        {categorizationReviewStore.reviewPageController.isLoadingDataSlow &&
            <Alert severity="info" sx={{minWidth: 400}}>
                Loading is taking longer than expected...
            </Alert>
        }
    </>;
});